var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.60596,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 30.606C24.9996 30.606 26.3121 32.106 28.4996 32.106C30.6871 32.106 31.9996 30.606 31.9996 30.606M31.2496 25.606H31.2596M25.7496 25.606H25.7596M28.4996 36.606C33.194 36.606 36.9996 32.8004 36.9996 28.106C36.9996 23.4115 33.194 19.606 28.4996 19.606C23.8052 19.606 19.9996 23.4115 19.9996 28.106C19.9996 29.056 20.1555 29.9695 20.443 30.8226C20.5512 31.1436 20.6053 31.3041 20.6151 31.4274C20.6247 31.5492 20.6174 31.6345 20.5873 31.7529C20.5568 31.8728 20.4894 31.9974 20.3547 32.2468L18.7191 35.2743C18.4857 35.7062 18.3691 35.9221 18.3952 36.0887C18.4179 36.2339 18.5034 36.3617 18.6288 36.4382C18.7728 36.526 19.0169 36.5008 19.5052 36.4503L24.6262 35.921C24.7813 35.9049 24.8588 35.8969 24.9295 35.8996C24.999 35.9023 25.0481 35.9088 25.1159 35.9244C25.1848 35.9403 25.2714 35.9737 25.4448 36.0405C26.3928 36.4057 27.4228 36.606 28.4996 36.606ZM31.7496 25.606C31.7496 25.8821 31.5258 26.106 31.2496 26.106C30.9735 26.106 30.7496 25.8821 30.7496 25.606C30.7496 25.3298 30.9735 25.106 31.2496 25.106C31.5258 25.106 31.7496 25.3298 31.7496 25.606ZM26.2496 25.606C26.2496 25.8821 26.0258 26.106 25.7496 26.106C25.4735 26.106 25.2496 25.8821 25.2496 25.606C25.2496 25.3298 25.4735 25.106 25.7496 25.106C26.0258 25.106 26.2496 25.3298 26.2496 25.606Z",
    stroke: "#0086C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.60596,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0F9FF",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/Quality.23f7bcfd406527696a77e4acc941014f.svg";
export { ForwardRef as ReactComponent };